import type { PlayerId } from './types'

const STORAGE_KEY = 'roam:arenal:play'

export interface PlayState {
  playerId?: PlayerId
  journeyId?: string
  completedJourneyIds: string[]
  lastPlayedAt?: string
}

export function loadPlayState(): PlayState {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}') as Partial<PlayState>
    return {
      playerId: parsed.playerId,
      journeyId: parsed.journeyId,
      completedJourneyIds: Array.isArray(parsed.completedJourneyIds)
        ? parsed.completedJourneyIds
        : [],
      lastPlayedAt: parsed.lastPlayedAt,
    }
  } catch {
    return { completedJourneyIds: [] }
  }
}

export function savePlaySelection(
  state: PlayState,
  playerId: PlayerId,
  journeyId: string,
): void {
  state.playerId = playerId
  state.journeyId = journeyId
  state.lastPlayedAt = new Date().toISOString()
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
}

export function markJourneyComplete(state: PlayState, journeyId: string): void {
  if (!state.completedJourneyIds.includes(journeyId)) {
    state.completedJourneyIds.push(journeyId)
  }
  state.lastPlayedAt = new Date().toISOString()
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
}
